export default __webpack_public_path__ + "static/media/wizard_white.dd2b757b.svg";